<template>
    <div class="languages" :class="languageDropdown ? 'opened' : 'closed'">
        <span v-on:click.stop="toggleDropdownMenu('lang')">
            <div class="language-hover d-flex align-items-center">
                <i :class="'icon language-' + locale + ' mr-2'"></i>
                <span class="lang">{{languages[locale]}}</span>
            </div>
        </span>
        <div class="dropdown-menu d-block" v-if="languageDropdown" @mouseleave="closeDropdownMenu()">
            <a class="dropdown-item" :class="'icon language-' + k" href="#" @click.prevent="setLang(k)" v-for="(l, k) in languages" v-bind:key="k" v-bind:class="{'active': k == locale}">{{l}}</a>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import headerMixin from './../mixins/header.js';

export default {
    name: 'Language',
     mixins: [
        headerMixin
    ],
    computed: {
        ...mapState('language', [
            'locale',
            'languages'
        ]),
        languageDropdown: function () {
            if(this.openedDropdown == 'lang') {
                return true;
            } else {
                return false; 
            }
        } 
    },
    mounted: function() {             
    },
    methods: {       
        ...mapActions({
            setLocale: 'language/setLocale'
        }),
        setLang(lang) {
            let oldLocale = this.locale;

            this.setLocale(lang);
            this.closeDropdownMenu();
            this.$root.$i18n.locale = this.locale;
            
            //if we are on desktop, we redirect to the new lang
            if(process.env.VUE_APP_DEVICE == 'desktop') {
                this.$store.dispatch('language/setHasLangInUrl', false);
                let url = window.location.origin + '/' + lang + window.location.pathname.replace('/' + oldLocale, '');
                window.location = url;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$lightgrey: lightgrey;
$green: #59af54;

.languages {
    display: inline-block;
    position: relative;
    margin-right: 10px;
    margin-left: 19px;
    .dropdown-menu {
        margin-top: 20px;
        .icon {
            background-position: 5px 5px;
            background-size: auto;
            width: auto;
            height: auto;
        }
        .dropdown-item {
            color: black;
            padding: 8px 40px;
            &.active {
                color: white;
            }
        }
    }
}
@media only screen and (max-width: 600px) {
    .language-hover {
        span {
            &.lang {
                font-weight: 500;
                line-height: unset;
            }
        }
        .icon {
            width: 26px;
            height: 26px;

        }
    }

}

</style>
